module.exports = "/kiosk/kiosk-launch-modal-0f800e.html";